import { Checkbox, Box, Tooltip } from "@mui/material";
import { useDispatch } from "react-redux";
import { commonSlice } from "src/store/common/common.slice";
import { styled } from "@mui/material/styles";
import checkmarkCircle2Fill from "@iconify/icons-eva/checkmark-circle-2-fill";
import { Icon } from "@iconify/react";

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  padding: theme.spacing(1),
  '& .MuiSvgIcon-root': {
    fontSize: 24,
  },
  '&.Mui-checked': {
    color: theme.palette.primary.main,
  },
}));


export const AccessCheckBox = ({ value, field, id, isReadOnly = false }) => {
  const dispatch = useDispatch();
  const isChecked = value === "Y";
  
  const handleChange = (event) => {
    if (isReadOnly) return;
    
    dispatch(
      commonSlice.actions.setFeatureAccess({
        value: event.target.checked ? "Y" : "N",
        accessName: field,
        id,
      })
    );
  };

  const checkbox = (
    <StyledCheckbox
      checked={isChecked}
      onChange={handleChange}
      disabled={isReadOnly}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover': {
          backgroundColor: isReadOnly ? 'transparent' : 'action.hover',
        }
      }}
    />
  );

  if (isReadOnly) {
    return (
      <Tooltip title="create permission disabled" placement="top">
        <span>{checkbox}</span>
      </Tooltip>
    );
  }

  return checkbox;
};
